import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "../store";

// Basic selectors
export const selectWireImportBatchesState = (state: RootState) =>
  state.wireImportBatches;

export const selectWireImportBatchesById = createSelector(
  [selectWireImportBatchesState],
  (wireImportBatchesState) => wireImportBatchesState.byId,
);

export const selectWireImportBatchesTotal = createSelector(
  [selectWireImportBatchesState],
  (wireImportBatchesState) => wireImportBatchesState.total,
);

export const selectSelectedWireImportBatch = createSelector(
  [selectWireImportBatchesState],
  (wireImportBatchesState) => wireImportBatchesState.selected,
);

export const selectWireImportBatchById = (id: string) =>
  createSelector([selectWireImportBatchesById], (byId) => byId[id]);
